import styled from "styled-components"

const HeaderExerciseStyle = styled.header`
    strong{
        font-size:1.25rem
    }
    border-bottom: 1px solid ${props => props.theme.main.borderLightGray};
`

export default HeaderExerciseStyle